import { render, staticRenderFns } from "./TempRankingHistory.vue?vue&type=template&id=1c9cd274"
import script from "./TempRankingHistory.vue?vue&type=script&lang=js"
export * from "./TempRankingHistory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports